module.exports = __webpack_public_path__ + "static/banner-desktop-empaques-3b0cf6c98fc50cf157ac0a6a0835d4f0.png";